module.exports = __webpack_public_path__ + "static/media/PricetagSelected.59b47abc.svg";